import React from 'react';
import AvatarsContainer from '../../Componant/UiKits/Avtars';

const Avatar = () => {
  return (
    <div className='page-body'>
      <AvatarsContainer />
    </div>
  );
};

export default Avatar;
